import { Node, mergeAttributes } from "@tiptap/core";

export const LabelNode = Node.create({
  name: "label",
  group: "block",
  content: "block+",
  defining: true,

  addAttributes() {
    return {
      for: {
        default: null,
        parseHTML: (element) => element.getAttribute("for"),
        renderHTML: (attributes) => (attributes.for ? { for: attributes.for } : {}),
      },
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute("style"),
        renderHTML: (attributes) => (attributes.style ? { style: attributes.style } : {}),
      },
      class: {
        default: null,
        parseHTML: (element) => element.getAttribute("class"),
        renderHTML: (attributes) => (attributes.class ? { class: attributes.class } : {}),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "label",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["label", mergeAttributes(HTMLAttributes), 0];
  },
});


